"use strict";

exports.__esModule = true;
exports.sumAllPixels = void 0;
var sumAllPixels = exports.sumAllPixels = function sumAllPixels() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.reduce(function (acc, curr) {
    return acc + Number(curr.replace(/px$/, ""));
  }, 0);
};